import {
    MoneyPoolCashin,
    MoneyPoolCashinTypePortion,
    MoneyPoolCashinTypeRepayment,
    MoneyPoolCashoutCustom,
    MoneyPoolCashoutReason,
    MoneyPoolCashoutTypeLoan,
    MoneyPoolTransactionTypes,
} from '../../../../../../utilities/helper/moneyPools'
import DeleteTransactionModal from 'components/modals/deleteTransaction'
import moment from 'jalali-moment'
import { useState } from 'react'
import classNames from 'classnames'
import { useNavigate, useParams } from 'react-router-dom'
import { ConvertJalaliDate } from 'utilities/helper/digitToMonth'

interface ITransactionDetails {
    item: IMoneyPoolTransactionResult
    isManager: boolean
    setIsOpen: () => void
}

export default function TransactionDetail({
    item,
    isManager,
    setIsOpen,
}: ITransactionDetails) {
    const navigate = useNavigate()
    const { id } = useParams()
    const [showDeleteTrxModal, setShowDeleteTrxModal] = useState<boolean>(false)
    return (
        <div className=" w-full text-center py-3">
            <div>
                <p>{MoneyPoolTransactionTypes[item.type]}</p>
            </div>
            <hr className=" my-2" />
            <div className="pr-4 pl-4">
                <div className="flex pt-2 pb-2 justify-content-between">
                    <p className="text-gray-2">مبلغ:</p>
                    <p>{item.amount && item.amount.toLocaleString()} تومان</p>
                </div>
                {item.type === MoneyPoolCashinTypePortion ||
                item.type === MoneyPoolCashinTypeRepayment ? (
                    <div>
                        <div className="flex pt-2 pb-2 justify-content-between">
                            <p className="text-gray-2">مربوط به:</p>
                            <p>
                                {item.transaction
                                    ? item.transaction.receiver_name
                                    : item.poolship_name}
                            </p>
                        </div>
                        <div className="flex pt-2 pb-2 justify-content-between">
                            <p className="text-gray-2">توسط:</p>
                            <p>
                                {item.transaction
                                    ? item.transaction.payer_name
                                    : item.registrar_name}
                            </p>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="flex pt-2 pb-2 justify-content-between">
                            <p className="text-gray-2">دریافت کننده:</p>
                            <p>
                                {item.transaction
                                    ? item.transaction.receiver_name
                                    : item.poolship_name}
                            </p>
                        </div>
                    </div>
                )}
                <div className="flex pt-2 pb-2 justify-content-between">
                    <p className="text-gray-2">
                        {item.type.substring(0, 2) === MoneyPoolCashin
                            ? 'تاریخ واریز:'
                            : 'تاریخ برداشت:'}
                    </p>
                    <p>
                        {item.jalali_time &&
                            moment
                                .from(item.jalali_time, 'YYYY-MM-DD HH:mm:ss')
                                .format('HH:mm:ss')}{' '}
                        {item?.jalali_time &&
                            ConvertJalaliDate(item.jalali_time)}
                    </p>
                </div>
                <div className="flex pt-2 pb-2 justify-content-between">
                    <p className="text-gray-2">مانده صندوق پس از تراکنش:</p>
                    <p>
                        {item.balance_after_transaction &&
                            item.balance_after_transaction.toLocaleString()}{' '}
                        تومان
                    </p>
                </div>
            </div>
            <hr className="my-2" />
            <div className="border-1 border-gray-7 text-gray-2 h-28 overflow-y-auto border-dashed m-3 rounded-md text-right">
                <p className="text-sm p-2">توضیحات: </p>

                {item.tag === '' ? (
                    <p className="text-center text-sm no-description">
                        توضیحی ثبت نشده است.
                    </p>
                ) : (
                    <p className="text-sm pr-2">{item.tag}</p>
                )}

                {item.type === MoneyPoolCashoutCustom && (
                    <p className="text-sm pr-2">
                        {MoneyPoolCashoutReason[item.reason]}
                    </p>
                )}
            </div>
            <div className="flex justify-content-center">
                {item.type === MoneyPoolCashoutTypeLoan ? (
                    <button
                        className={classNames(
                            'w-5/12 ml-3 p-1 bg-green-1 py-2 text-center text-white rounded-xl'
                        )}
                    >
                        اطلاعات وام
                    </button>
                ) : isManager ? (
                    <button
                        className={classNames(
                            'w-5/12 ml-3 p-1 bg-green-1 py-2 text-center text-white rounded-xl'
                        )}
                        onClick={() =>
                            navigate(
                                `/fund/financial-history/${id}/${item.poolship}`
                            )
                        }
                    >
                        اطلاعات عضو
                    </button>
                ) : (
                    <button
                        className={classNames(
                            'w-10/12 ml-3 p-1 bg-green-1 py-2 text-center text-white rounded-xl'
                        )}
                        onClick={() => setIsOpen()}
                    >
                        بازگشت
                    </button>
                )}

                <button
                    className=" w-5/12 border-1 border-red-3 py-1 text-center rounded-xl text-red-3"
                    onClick={() => setShowDeleteTrxModal(true)}
                    hidden={!isManager || item.transaction !== null}
                >
                    حذف تراکنش
                </button>
            </div>
            <DeleteTransactionModal
                show={showDeleteTrxModal}
                onHide={() => setShowDeleteTrxModal(false)}
                moneypoolId={Number(id)}
                transactionId={item.id}
                isMoneypoolCashin={
                    item.type.substring(0, 2) === MoneyPoolCashin
                }
            />
        </div>
    )
}
